import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitaxiservice() {



const cardData = {
  keyword: " Navi Mumbai Taxi Service",

headingDescription:
  "Omshree Cab offers reliable and comfortable Navi Mumbai taxi services for travelers looking for convenient transportation within the city as well as for airport transfers and outstation trips. Whether you need a cab for daily travel, business meetings, family outings, sightseeing, or airport pickup and drop, our taxi service ensures a safe and hassle-free journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including local hourly rentals, one-way rides, round-trip bookings, and full-day taxi services with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from homes, offices, hotels, and railway stations, professional chauffeurs familiar with Navi Mumbai routes, and 24/7 customer support, Omshree Cab is your trusted partner for dependable taxi services in Navi Mumbai.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest and most beautifully designed urban parks in Navi Mumbai. The park features landscaped gardens, jogging tracks, fountains, open spaces, and recreational areas where visitors can relax and enjoy nature. Families often come here for picnics, morning walks, and outdoor activities. The peaceful surroundings and lush greenery make it a refreshing destination away from the busy city environment. Using a Navi Mumbai taxi service allows travelers to conveniently visit the park and spend time enjoying its calm and scenic atmosphere."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a scenic natural attraction located near Kharghar and is especially popular during the monsoon season. The waterfall flows from a height of over 100 meters and is surrounded by green hills and forested landscapes. Visitors often come here for photography, nature walks, and enjoying the cool refreshing environment. The location is believed to be associated with stories from the Mahabharata, adding cultural significance to the place. A taxi service in Navi Mumbai makes it easy for visitors to reach this beautiful natural spot comfortably."
  },
  {
    title: "DY Patil Stadium",
    description:
      "DY Patil Stadium is a major sports and entertainment venue in Navi Mumbai known for hosting international cricket matches, football events, concerts, and large public gatherings. The stadium features modern architecture and world-class facilities that attract sports fans and visitors from across the region. During major events the surrounding area becomes lively with crowds and celebrations. Booking a Navi Mumbai taxi service provides convenient transport to the stadium without worrying about traffic or parking."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is one of the largest shopping and entertainment centers in Navi Mumbai. The mall features international retail brands, restaurants, cafes, cinemas, and leisure activities for visitors of all ages. People often spend time shopping, watching movies, and enjoying meals with family and friends. The mall is connected to the Seawoods railway station and serves as a major lifestyle hub in the region. A taxi service allows visitors to travel comfortably to this vibrant shopping destination."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is a scenic and well-planned coastal road that connects Vashi, Nerul, and Belapur in Navi Mumbai. The road is known for its smooth traffic flow, beautiful skyline views, and picturesque surroundings. Many people enjoy evening drives along this stretch because of the calm environment and waterfront scenery. A taxi ride along Palm Beach Road offers a relaxing experience and is a great way to explore the city."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic structure located near CBD Belapur and dates back several centuries. The fort once served as an important defense point and reflects the region’s historical heritage. Visitors can explore the ruins, stone walls, and surrounding greenery while learning about its historical significance. The location also offers scenic views of the surrounding area. Hiring a taxi in Navi Mumbai makes it easy for tourists to reach this historical landmark."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well-known landmark in Kharghar recognized for its unique architectural design and decorative fountains. The area around the chowk has several cafes, restaurants, and shops where visitors can relax and spend leisure time. In the evening the place becomes lively with people enjoying the illuminated surroundings and vibrant atmosphere. Travelers using a Navi Mumbai taxi service can conveniently include this landmark in their sightseeing route."
  },
  {
    title: "Kharghar Hills",
    description:
      "Kharghar Hills offer beautiful panoramic views of Navi Mumbai and the surrounding landscapes. Nature lovers often visit the hills for trekking, hiking, and photography. The peaceful environment and natural greenery make it a refreshing getaway from busy city life. During sunrise and sunset the views from the hilltops are particularly stunning. Booking a taxi in Navi Mumbai allows visitors to comfortably reach this scenic natural location."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple is a beautiful temple dedicated to Lord Venkateswara and is designed in traditional South Indian architectural style. The temple is known for its detailed carvings, peaceful atmosphere, and spiritual significance among devotees. Visitors come to offer prayers and admire the temple’s elegant design and surroundings. A taxi service in Navi Mumbai provides convenient transportation for devotees and tourists visiting this religious site."
  },
  {
    title: "Sagar Vihar",
    description:
      "Sagar Vihar is a scenic waterfront promenade located in Vashi overlooking the Thane Creek. The area is popular for evening walks, photography, and relaxing by the water while enjoying cool sea breezes. Visitors often gather here to watch beautiful sunset views across the creek. The calm environment makes it a pleasant place for families and tourists to spend time outdoors. A Navi Mumbai taxi service allows travelers to easily reach this peaceful waterfront destination."
  }
],



services: [
{
name: "Navi Mumbai Taxi Service",
description: "Navi Mumbai taxi service provides reliable and comfortable transportation for daily travel, airport transfers, and outstation journeys across the city. Our fleet includes well-maintained sedans, SUVs, and premium vehicles designed for smooth travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, and railway stations. Air-conditioned vehicles ensure comfortable rides during city travel. Ideal for business travelers, tourists, and local commuters. Flexible booking options make travel convenient for short and long-distance trips."
},
{
name: "Taxi Service Navi Mumbai",
description: "Taxi service Navi Mumbai offers convenient city transportation for passengers traveling within Navi Mumbai and nearby areas. Vehicles provide comfortable seating and smooth ride quality suitable for daily travel. Professional drivers ensure punctual pickups and safe driving across the city. Pickup services are available from residential areas, business districts, hotels, and transport hubs. Ideal for office travel, family trips, and local sightseeing."
},
{
name: "Navi Mumbai Taxi Booking",
description: "Navi Mumbai taxi booking allows passengers to easily reserve vehicles for city rides and intercity travel. Booking options include online reservations and quick phone confirmations. Vehicles provide comfortable seating and reliable ride performance suitable for city travel. Professional drivers ensure punctual pickup services across Navi Mumbai."
},
{
name: "Taxi Booking Navi Mumbai",
description: "Taxi booking Navi Mumbai service provides fast and convenient reservations for passengers needing reliable transportation. Vehicles are clean, air-conditioned, and suitable for city travel. Professional drivers ensure safe driving and punctual pickups from homes, offices, hotels, and transport hubs."
},
{
name: "Cheap Taxi Service Navi Mumbai",
description: "Cheap taxi service Navi Mumbai provides affordable city transportation without compromising comfort or safety. Passengers can travel in clean vehicles with professional drivers at economical pricing. Ideal for students, daily commuters, and budget travelers needing convenient city rides."
},
{
name: "Best Taxi Service Navi Mumbai",
description: "Best taxi service Navi Mumbai offers premium transportation with reliable drivers and comfortable vehicles. The service ensures punctual pickups, smooth ride quality, and excellent customer support. Ideal for corporate travelers, families, and tourists visiting Navi Mumbai."
},
{
name: "Airport Taxi Navi Mumbai",
description: "Airport taxi Navi Mumbai provides dependable transportation for passengers traveling to or from Mumbai and Navi Mumbai airports. Vehicles provide comfortable seating and sufficient luggage space for airport transfers. Professional drivers ensure timely pickups and safe driving throughout the journey."
},
{
name: "Local Taxi Navi Mumbai",
description: "Local taxi Navi Mumbai service offers convenient transportation for short city trips and daily travel within Navi Mumbai. Vehicles provide comfortable seating and reliable ride quality suitable for city journeys. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Outstation Taxi Navi Mumbai",
description: "Outstation taxi Navi Mumbai provides comfortable long-distance transportation from Navi Mumbai to destinations across Maharashtra and India. Vehicles offer smooth highway performance and spacious seating suitable for extended journeys. Ideal for family vacations, pilgrimage tours, and corporate travel."
},
{
name: "Taxi Near Me Navi Mumbai",
description: "Taxi near me Navi Mumbai service helps passengers quickly find available taxis nearby for immediate travel. Our network of vehicles ensures fast pickup from homes, offices, hotels, and public places across Navi Mumbai. Comfortable vehicles and professional drivers ensure reliable travel."
},
{
name: "24 Hour Taxi Navi Mumbai",
description: "24 hour taxi Navi Mumbai service provides round-the-clock transportation for passengers traveling at any time of day or night. Whether early morning trips or late-night travel, drivers are available to ensure safe and reliable transportation."
},
{
name: "Reliable Taxi Navi Mumbai",
description: "Reliable taxi Navi Mumbai service offers safe and dependable transportation for city travel and intercity journeys. Vehicles are well maintained and operated by experienced drivers ensuring smooth travel across Navi Mumbai."
},
{
name: "Corporate Taxi Navi Mumbai",
description: "Corporate taxi Navi Mumbai service provides professional transportation for business travelers and company employees. Vehicles offer comfortable seating and punctual pickup services suitable for office travel and corporate airport transfers."
},
{
name: "Luxury Taxi Navi Mumbai",
description: "Luxury taxi Navi Mumbai service offers premium vehicles for passengers seeking high-end travel comfort. Luxury sedans and SUVs provide spacious seating, superior ride quality, and professional chauffeur service."
},
{
name: "Online Taxi Booking Navi Mumbai",
description: "Online taxi booking Navi Mumbai provides quick digital reservations for passengers needing reliable transportation. Travelers can easily schedule rides online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride quality suitable for city and outstation travel."
}
],

tableData: [
["Navi Mumbai Taxi Service","Taxi Service Navi Mumbai"],
["Navi Mumbai Taxi Booking","Taxi Booking Navi Mumbai"],
["Cheap Taxi Service Navi Mumbai","Best Taxi Service Navi Mumbai"],
["Airport Taxi Navi Mumbai","Local Taxi Navi Mumbai"],
["Outstation Taxi Navi Mumbai","Taxi Near Me Navi Mumbai"],
["24 Hour Taxi Navi Mumbai","Reliable Taxi Navi Mumbai"],
["Corporate Taxi Navi Mumbai","Luxury Taxi Navi Mumbai"],
["Online Taxi Booking Navi Mumbai","City Taxi Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Local Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Navi Mumbai city routes including Vashi, Nerul, Belapur, Kharghar, and Panvel. They understand traffic patterns and the fastest routes ensuring smooth and timely travel."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai taxi services. Customers receive clear information about travel fares, per-kilometer charges, and waiting time before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our Navi Mumbai taxi service operates 24 hours a day. Whether you need a cab early morning, late night, or anytime during the day, our taxis are always available."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to provide a comfortable city travel experience."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible taxi services including local travel, airport pickup and drop, corporate travel, and outstation trips from Navi Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business centers anywhere in Navi Mumbai."
  },
  {
    WhyChooseheading: "Reliable Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable taxi services in Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide taxi service in Navi Mumbai?", answer: "Yes, Omshree Cabs provides reliable taxi services across Navi Mumbai including Vashi, Nerul, Belapur, Kharghar, and Panvel." },
  { question: "Is taxi service available 24 hours in Navi Mumbai?", answer: "Yes, our Navi Mumbai taxi service operates 24/7 for customer convenience." },
  { question: "Which vehicles are available for taxi booking?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers depending on travel requirements." },
  { question: "Do you provide airport taxi services?", answer: "Yes, we provide airport pickup and drop services to Mumbai Airport and Navi Mumbai Airport." },
  { question: "Can I book taxi service for outstation travel?", answer: "Yes, Omshree Cabs provides outstation taxi services from Navi Mumbai to destinations like Pune, Nashik, Lonavala, Shirdi, and Goa." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book taxi service online?", answer: "Yes, customers can easily book taxi services online or through phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak travel hours and weekends." },
  { question: "Do you provide corporate taxi services?", answer: "Yes, we provide taxi services for corporate travel, employee transportation, and business meetings." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Patil",
    feedback:
      "Booked a taxi with Omshree Cabs in Navi Mumbai. The driver was punctual and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Very reliable taxi service in Navi Mumbai. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides reliable taxi services in Navi Mumbai, including local, outstation, airport, corporate, and luxury taxis with 24x7 online booking.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": [
    "Local Taxi Service",
    "Outstation Taxi Service",
    "Airport Taxi Service",
    "Corporate Taxi Service",
    "Luxury Taxi Service"
  ]
};








  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Taxi Service | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers the best taxi service in Navi Mumbai. Book local, outstation, airport, corporate, or luxury taxis online 24x7. Affordable and reliable taxi service near you." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitaxiservice;